import api from './api'
import authService from './authService'

const formatDateForInsert = (dateStr) => {
  // Input: dd/mm/yyyy → Output: yyyy/mm/dd
  if (!dateStr || dateStr.length < 10) return ''
  const parts = dateStr.split('/')
  if (parts.length < 3) return dateStr
  return `${parts[2]}/${parts[1]}/${parts[0]}`
}

export const documentoService = {
  saveNormaLegal(payload) {
    const formData = new FormData()

    formData.append('id', payload.id || '')
    formData.append('id_tipo_nl', payload.id_tipo_nl || '')
    formData.append('numero', payload.numero || '')
    formData.append('fecha_firma', payload.fecha_firma || '')
    formData.append('caracter', payload.caracter || '')
    formData.append('id_voz_nl', payload.id_voz_nl || '')
    formData.append('resena', payload.resena || '')
    formData.append('nl_afectadas', JSON.stringify(payload.nl_afectadas || []))
    formData.append('oficinas_notif', JSON.stringify(payload.oficinas_notif || []))
    formData.append('cambio_pdf', payload.cambio_pdf ? 'true' : 'false')

    if (payload.cambio_pdf && payload.file) {
      formData.append('file', payload.file)
    }

    return api.post('/api/v1.0/spa/nl/', formData)
  },

  triggerOCRProcessing(idNormaLegal) {
    return api.get(`/api/v1.0/spa/docs/ocr?id_norma_legal=${idNormaLegal}`)
  },

  sendEmail(listToEmail) {
    return api.post('/api/v1.0/spa/send-mail/', listToEmail)
  },

  postDoc(doc, meta) {
    const areas = authService.getUserDataArea()
    const formData = new FormData()
    formData.append('numero', meta.numero)
    formData.append('descripcion_oficina', areas[0])
    formData.append('file', doc)
    return api.post('/api/v1.0/spa/nl/', formData)
  },

  getNormasLegales(criterios) {
    let params = `&rol_auth=${authService.getUserDataArea()[0]}`

    if (criterios.numero) params += `&numero=${criterios.numero}`
    if (criterios.idVoz) params += `&id_voz_nl=${criterios.idVoz}`
    if (criterios.caracter) params += `&caracter=${criterios.caracter.toLowerCase()}`
    if (criterios.idTipo) params += `&id_tipo_nl=${criterios.idTipo}`
    if (criterios.resena) params += `&resena=${criterios.resena}`
    if (criterios.fechaDesde) params += `&ffirma_desde=${formatDateForInsert(criterios.fechaDesde)}`
    if (criterios.fechaHasta) params += `&ffirma_hasta=${formatDateForInsert(criterios.fechaHasta)}`
    if (criterios.rows) params += `&limit=${criterios.rows}`
    if (criterios.first !== undefined && criterios.first !== '') params += `&skip=${criterios.first}`

    return api.get(`/api/v1.0/spa/pub/nl/?${params}`)
  },

  updateNormaLegal(object) {
    return api.put('/api/v1.0/spa/nl/', object)
  },

  deleteNormaLegal(idNormaLegal) {
    return api.delete(`/api/v1.0/spa/nl/?id=${idNormaLegal}`)
  },

  getDocumento(idPdf) {
    const rol = authService.getUserRol()
    if (rol === 'PUBLIC') {
      return api.get(`/api/v1.0/spa/pub/docs?id_pdf=${idPdf}`, { responseType: 'blob' })
    }
    return api.get(`/api/v1.0/spa/docs?id_pdf=${idPdf}`, { responseType: 'blob' })
  },

  getNormaById(idNormaLegal) {
    const rol = authService.getUserRol()
    if (rol === 'PUBLIC') {
      return api.get(`/api/v1.0/spa/pub/nl/?id=${idNormaLegal}`)
    }
    return api.get(`/api/v1.0/spa/nl/?id=${idNormaLegal}`)
  },

  updatePdf(idNormaLegal, doc, meta) {
    const areas = authService.getUserDataArea()
    const formData = new FormData()
    formData.append('id', idNormaLegal)
    formData.append('numero', meta.numero)
    formData.append('descripcion_oficina', areas[0])
    formData.append('file', doc)
    return api.put('/api/v1.0/spa/nl/doc/', formData)
  },
}

export default documentoService
